module.exports = __webpack_public_path__ + "static/partner-img4-e137b8ea27cbf2f485054a9f5256d54d.png";